/**
 * Página de login. Redirige a Microsoft Entra ID (solo cuentas @dfds.com).
 */
import { useSearchParams } from 'react-router-dom';
import { useMemo } from 'react';
import styles from './LoginPage.module.css';

const AUTH_ERRORS: Record<string, string> = {
    domain_not_allowed: 'Solo se permiten cuentas corporativas @dfds.com.',
    tenant_mismatch: 'La cuenta no pertenece al directorio corporativo autorizado.',
    account_disabled: 'Tu cuenta está desactivada. Contacta con un administrador.',
    invalid_state: 'La sesión de inicio expiró. Inténtalo de nuevo.',
    not_configured: 'El inicio de sesión con Microsoft no está configurado en el servidor.',
    auth_failed: 'No se pudo completar el inicio de sesión con Microsoft.',
};

export function LoginPage() {
    const [searchParams] = useSearchParams();
    const errorCode = searchParams.get('auth_error');

    const error = useMemo(() => {
        if (!errorCode) return '';
        return AUTH_ERRORS[errorCode] || AUTH_ERRORS.auth_failed;
    }, [errorCode]);

    return (
        <div className={styles.container}>
            <div className={styles.card}>
                <div className={styles.headerStrip}>
                    <img
                        src="/apple-touch-icon.png"
                        alt="RossBoard"
                        className={styles.headerLogo}
                    />
                    <span className={styles.headerTitle}>RossBoard</span>
                </div>

                <div className={styles.form}>
                    {error && (
                        <div className={styles.errorBox}>
                            <p className={styles.errorText}>{error}</p>
                        </div>
                    )}

                    <div className={styles.buttonContainer}>
                        <a href="/auth/microsoft" className={styles.microsoftButton}>
                            <svg
                                className={styles.microsoftIcon}
                                viewBox="0 0 21 21"
                                aria-hidden
                                focusable="false"
                            >
                                <rect x="1" y="1" width="9" height="9" fill="#f25022" />
                                <rect x="11" y="1" width="9" height="9" fill="#7fba00" />
                                <rect x="1" y="11" width="9" height="9" fill="#00a4ef" />
                                <rect x="11" y="11" width="9" height="9" fill="#ffb900" />
                            </svg>
                            Iniciar sesión con Microsoft
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
}
